import { FC } from "react";
import { Alert, Typography } from "@mui/material";

interface FilterValueWithBatchInputAlertProps {
  count: number;
  valid?: boolean;
}

export const FilterValueWithBatchInputAlert: FC<
  FilterValueWithBatchInputAlertProps
> = ({ valid, count }) => {
  return (
    <Alert severity={valid ? "success" : "warning"} variant="outlined">
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="inherit">
          {count}
        </Typography>
        {` value${count > 1 ? "s " : " "}${!valid ? "could not be" : ""} found.`}
      </Typography>
    </Alert>
  );
};
